import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import "./styles.less";

export const Card = (props) => {
  const { title, subtitle, icon, link } = props;
  const enterDetail = () => {
    window.open(link);
  };
  return (
    <div
      className="zero-idaas-card"
      onClick={() => {
        enterDetail(link);
      }}
    >
      <div className="zero-idaas-card-top">
        <div className="icon">
          <img
            src={`//files.authing.co/authing-website/${icon}`}
            alt="authing"
          />
        </div>
        <div className="card-title">{title}</div>
        <div className="card-arrow">
          <i className="icon authing-icon authing-arrow-right-line"></i>
        </div>
      </div>
      <div className="subtitle">{subtitle}</div>
    </div>
  );
};

export const ZeroIdaas = (props) => {
  const { t } = useTranslation();
  const CardLeftData = [
    {
      icon: "zero-trust-icon1.png",
      link: "https://docs.authing.cn/v2/guides/authentication/",
      title: t("zeroTrust.idaas.item1.title"),
      subtitle: t("zeroTrust.idaas.item1.subtitle"),
    },
    {
      icon: "zero-trust-icon2.png",
      link: "https://www.authing.co/learn/sso",
      title: t("zeroTrust.idaas.item2.title"),
      subtitle: t("zeroTrust.idaas.item2.subtitle"),
    },
    {
      icon: "zero-trust-icon3.png",
      link: "https://www.authing.co/mfa",
      title: t("zeroTrust.idaas.item3.title"),
      subtitle: t("zeroTrust.idaas.item3.subtitle"),
    },
  ];
  const CardRightData = [
    {
      icon: "zero-trust-icon4.png",
      link: "https://www.authing.co/authorization-management",
      title: t("zeroTrust.idaas.item4.title"),
      subtitle: t("zeroTrust.idaas.item4.subtitle"),
    },
    {
      icon: "zero-trust-icon5.png",
      link:
        "https://docs.authing.cn/v2/concepts/account-life-cycle-management.html",
      title: t("zeroTrust.idaas.item5.title"),
      subtitle: t("zeroTrust.idaas.item5.subtitle"),
    },
    {
      icon: "zero-trust-icon6.png",
      link: "https://docs.authing.cn/v2/guides/sync-new/",
      title: t("zeroTrust.idaas.item6.title"),
      subtitle: t("zeroTrust.idaas.item6.subtitle"),
    },
  ];
  return (
    <div>
      <section className="zero-trust-idaas">
        <div className="inner">
          <div className="title">{t("zeroTrust.idaas.title")}</div>
          <div className="subtitle">{t("zeroTrust.idaas.subtitle1")}</div>
          <div className="subtitle subtitle2">
            {t("zeroTrust.idaas.subtitle2")}
          </div>
          <div className="zero-idaas-warp">
            <div className="card-left">
              {CardLeftData.map((item) => (
                <Card {...item} />
              ))}
            </div>
            <div className="img-center">
              <img
                src="//files.authing.co/authing-website/zero-trust-idaas.png"
                alt="authing"
              />
            </div>
            <div className="card-right">
              {CardRightData.map((item) => (
                <Card {...item} />
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
